import { render } from "./Contacts.vue?vue&type=template&id=72b297ce&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=72b297ce&scoped=true&lang=css"

import exportComponent from "/Users/medvedevpavel/Documents/code/lb_advice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b297ce"]])

export default __exports__